module.exports = __webpack_public_path__ + "media/images/education/zuglo_lego1_2-a67a80fd111b5571fc73d2e478c8f79b.jpg";